import { Injectable } from '@angular/core';
import { FlowChartDataService } from '@features/data-survey/services/flow-chart-data.service';
import {skip, take, takeUntil} from 'rxjs/operators';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import { CommandService } from '@core/services/command.service';
import { SnackBarService } from '@core/services/snack-bar.service';
import { DialogService } from '@shared/services/dialog-service';
import { Guid } from 'guid-typescript';
import { ExtractedFieldModel } from '@shared/models/pdf-form-viewer/extracted-field.model';
import { DialogModel } from '@shared/models/dialog.model';
import { FlexSheetService } from '@features/spreadsheet/services/flex-sheet.service';
import { Subject } from 'rxjs';
import { FieldDefinition } from '@shared/models/field-definition';
import { PlatformCommand } from '@shared/commands/command-base';
import { PdfFormFieldDefinition } from '@shared/models/pdf-form-viewer/pdf-form-metadata.model';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import { PlatformQuery } from '@shared/models/platform-query/platform-query';
import { PlatformQueryService } from '@core/services/platform-query.service';
import {VirtualGridApiService} from '@core/services/virtual-grid-api.service';
import { FlexSheetNavigationService } from './flex-sheet-navigation.service';
@Injectable({providedIn: 'root'})
export class ConfigureExcelAsFormService {
  flowChartSection: any;
  ngUnsubscribe: Subject<void>;
  selectedTab: any;
  invalidateSubject: InvalidateSubject;
  constructor(
    private flowChartDataService: FlowChartDataService,
    private fuseSplashScreenService: FuseSplashScreenService,
    private commandService: CommandService,
    private snackBarService: SnackBarService,
    private dialogService: DialogService,
    public flexSheetService: FlexSheetService,
    public navigationService: FlexSheetNavigationService,
    private platformQueryService: PlatformQueryService,
    private virtualGridApiService: VirtualGridApiService,
  ) {
  }

  configureFlowChartService() {
    this.cleanSelectedCellModel$Subscription();
    this.ngUnsubscribe = new Subject<void>();
    this.flowChartSection = this.selectedTab.tabData.FlowChartSection;
    this.flowChartDataService.initFlowchartData();
    this.flowChartDataService.setApi('SpreadsheetApi');
    this.flowChartDataService.setIsManageFields(false);
    this.flowChartDataService.setFlowchartId(this.flowChartSection.flowchartId);
    this.flowChartDataService.setSourceType(this.flowChartSection.flowchartId);
    this.flowChartDataService.fetchCustomDataTypes('');
    // this.getConfiguredFields();
    this.invalidateSubject.getObservale().pipe(skip(1), takeUntil(this.ngUnsubscribe)).subscribe((state: any) => {
      this.getConfiguredFields();
    });
  }

   createCustomField() {
    const query = new PlatformQuery();
    query.api = 'FileStoreApi';
    query.name = 'ExcelFormExtractFieldItemQuery';
    const worksheet = this.flexSheetService.getCurrentWorkSheet();
    query.fieldValues['WorksheetId'] = worksheet.id;
    query.fieldValues['PageNumber'] = this.navigationService.getSheetPagination().pageNumber;
    query.fieldValues['CellModel'] = this.flexSheetService.selection.cellModel;
    query.fieldValues['FlowchartSectionId'] = this.flowChartSection.id;
    query.fieldValues['ExcelFormDefinitionId'] = this.selectedTab.tabData.ExcelFormDefinitionId;
    this.fuseSplashScreenService.show();
    this.platformQueryService.executeQuery(query).subscribe(response => {
      this.fuseSplashScreenService.hide();
      if (response.fieldValues['FieldDefinition']) {
        const fieldDefinition = response.fieldValues['FieldDefinition'];
        this.snackBarService.showWarning('Already Created A Field');
      } else {
        this.showCustomField(this.flexSheetService.selection.cellModel);
      }
    }, error => {
      this.fuseSplashScreenService.hide();
    });
  }

  showCustomField(cellModel: any) {
   // let fieldDefinition = new FieldDefinition();
   // fieldDefinition = this.getFieldDefinition(fieldDefinition, this.flowChartDataService.sourceType);
   // if (!fieldDefinition.metaData) {fieldDefinition.metaData = {}; }
    // fieldDefinition.metaData['CellModel'] = cellModel;
   // fieldDefinition.dataType = 'String';
    const editFieldDetails = this.flowChartDataService.getFieldDetailsConfig({}, false, 'ADD', true, '', this.flowChartSection);
    editFieldDetails.fieldDefinition.dataType = 'String';
    if (!editFieldDetails.fieldDefinition.configKey) {
      editFieldDetails.fieldDefinition.configKey = 'null'; // this is coded in field editor dialog like this. :(
    }
    const input = {'editFieldDetails': editFieldDetails};
    const dialogModel: DialogModel = DialogModel.create(
      'Add Custom Field From ' + this.flexSheetService.selection.position,
      'FieldEditorDialogComponent', input,
      '700px',
      '700px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).pipe(take(1)).subscribe(res => {
      if (res.action === 'OK') {
        const command = this.createCustomFieldCommand(res);
        command.fieldValues['CellModel'] = cellModel;
        this.fuseSplashScreenService.show();
        this.commandService.executePlatformCommand(command).pipe(take(2)).subscribe(response => {
            this.invalidateSubject.invalidate();
            this.fuseSplashScreenService.hide();
          },
          error => {
            this.fuseSplashScreenService.hide();
            console.error('[Excel] Add Custom field failed! ', error);
          });
      }
    });
  }
  getFieldDefinition(fieldDefinition: FieldDefinition, sourceType: string) {
    const customDataTypes = this.flowChartDataService.getCustomDataTypes('');
    if (customDataTypes && customDataTypes.length > 0) {
      let expectedDateType = 'String';
      switch (fieldDefinition.dataType) {
        case 'Checkbox':
          expectedDateType = 'Boolean';
          break;
        case 'Radiobutton':
          expectedDateType = 'Dropdown';
          break;
        case 'ChoiceBox': // todo: need to take decision
          if (fieldDefinition.metaData.isMultiSelect) {
            expectedDateType = 'List';
          } else {
            expectedDateType = 'Dropdown';
          }
          break;
      }
      const f = customDataTypes.find(dataType => {
        return  dataType.dataType === expectedDateType;
      });
      const fieldDefintion = JSON.parse(JSON.stringify(f));
      return fieldDefintion;
    } else {
      return undefined;
    }
  }
  handleMagicLinkValueChanged(action: any) {
    if (action) {
      switch (action.name) {
        case 'CardViewFieldDefinitionUpdateChanges':
          // this.handleCardViewFieldDefinitionUpdateChanges(action.value);
          return;
        case 'CardViewCheckboxSelectionChanges':
          this.handleCardViewSelectionChangesEvent(action.value);

          // this.flowChartDataService.addOrUpdateFieldDefinitionInFlowChartCommandExecute()
          return;
      }

    }
  }
  private handleCardViewSelectionChangesEvent($event: any) {
    console.log('here:', $event);
    if ($event && $event['status'] === 'Pending') {
      this.handleCardViewSelectionChangesBeforeCommandPostingEvent($event);
    } else if ($event['status'] === 'Success') {
      this.flowChartDataService.invalidateGridDataIfNeeded();
      const response = $event.successPayload;
      if (response && response.fieldValues && response.fieldValues['FlowchartSection']) {
        $event['flowchartSection'] = response.fieldValues['FlowchartSection'];
        if ($event.hasOwnProperty('selectAll')) {
          // this.handleCardViewSelectionAllChangedSuccess($event);
        } else {
          // this.handleCardViewSelectionChangedSuccess($event); // this.doesn't need anymore
        }
      }
    }
  }
  private handleCardViewSelectionChangesBeforeCommandPostingEvent($event: any) {
    const platformCommand = $event['UpdateGridCartItemCheckStatusCommand'];
    if ($event.hasOwnProperty('selectAll')) { // check or uncheck select all; we will use seperate delete interaction than usual
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(platformCommand).pipe(take(1)).subscribe(response => {
        this.fuseSplashScreenService.hide();
        this.handleCardViewSelectionChangesEvent(Object.assign({}, $event, {
          'status': 'Success',
          'successPayload': response
        }));
        // this.invalidateSubject.invalidate();
      }, err => {
        this.fuseSplashScreenService.hide();
        this.snackBarService.showError('Operation failed!');
        // this.invalidateSubject.invalidate();
      });

    } else { // we will use common delete interaction
      const checkedItems = $event.checkedItems; // only one item should be checked
      const unCheckedItems = $event.unCheckedItems; // only one item should be unChecked
      if (unCheckedItems && unCheckedItems.length === 1) {
        const extractedFieldItem = unCheckedItems[0];
        if (extractedFieldItem.fieldValues && extractedFieldItem.fieldValues.Source && extractedFieldItem.fieldValues.Source === 'FillablePdf') {
          const pageNo = extractedFieldItem.fieldValues.PageNo;
          const fieldKey = extractedFieldItem.fieldKey;
          // const field = this.getFieldFromFillablePdfDefinition(fieldKey, pageNo);
          // this.delete(field, pageNo, true, true);
        }
      }
      if (checkedItems && checkedItems.length === 1) {
        const extractedFieldItem = checkedItems[0];
        if (extractedFieldItem.fieldValues && extractedFieldItem.fieldValues.Source && extractedFieldItem.fieldValues.Source === 'FillablePdf') {
          const pageNo = extractedFieldItem.fieldValues.PageNo;
          const fieldKey = extractedFieldItem.fieldKey;
          // const field = this.getFieldFromFillablePdfDefinition(fieldKey, pageNo);
          // this.addOrEditQuestionForThisField(field, pageNo, true);
        }
      }
    }
  }

  delete(field: any, pageNo: string, isQuestion = false, invalidateVirtualCardGrid = false) {
    const message = `The ${isQuestion ? 'question and its responses' : 'field'} will be deleted permanently.`;
    const question = `Are you sure you want to delete this ${isQuestion ? 'configuration' : 'field'}?`;
    this.dialogService.showConfirmDialog('Clear Configuration', 'Clear', 'Cancel', message, question).subscribe(dialogState => {
      if (dialogState.action === 'OK') {
        // this.deleteSelectedField(field, pageNo, isQuestion, invalidateVirtualCardGrid);
      } else {
        if (invalidateVirtualCardGrid) {
          // this.invalidateSubject.invalidate();
        }
      }
    });
  }

  createCustomFieldCommand(res) {
    const fieldDefinition = res.data.input.editFieldDetails.fieldDefinition;
    const dateFormat = res.data.input.editFieldDetails.selectedDateFormat;
    if (fieldDefinition.dataType === 'DateTime' && dateFormat) {
      fieldDefinition['format'] = dateFormat.format;
    }
    const command = new PlatformCommand('CreateCustomFieldForExcelFormCommand', 'FileStoreApi');
    const workbook = this.flexSheetService.getCurrentWorkBook();
    const worksheet = this.flexSheetService.getCurrentWorkSheet();
    command.fieldValues['WorkbookId'] = workbook.id;
    command.fieldValues['WorksheetId'] = worksheet.id;
    command.fieldValues['WorksheetName'] = worksheet.name;
    command.fieldValues['DirectoryEntryId'] = this.selectedTab.tabData.DirectoryEntryId;
    command.fieldValues['FileId'] = this.selectedTab.tabData.FileId;
    command.fieldValues['ExcelFormDefinitionId'] = this.selectedTab.tabData.ExcelFormDefinitionId;
    command.fieldValues['IsClientDrive'] = this.selectedTab.tabData.IsClientDrive;
    command.fieldValues['FieldDefinition'] = fieldDefinition;
    command.fieldValues['FlowchartSectionId'] = this.flowChartSection.id;
    command.fieldValues['SourceFieldSectionId'] = this.flowChartSection.sourceFieldSectionId;
    command.fieldValues['QuestionType'] = 'Question';
    command.fieldValues['IsManageFields'] = false;
    command.fieldValues['PageNumber'] = this.navigationService.getSheetPagination().pageNumber;
    return command;
  }
  getConfiguredFields() {
    const req = {
      'startIndex': 0,
      'endIndex': 1000,
      'fieldSectionId': 'extractedfield',
      'sortField': 'FieldKey',
      'isAssending': true,
      'serviceName': 'ExtractedFieldDynamicItemService',
      'api': 'FileStoreApi',
      'parameters': {
        'TableId': this.selectedTab.tabData.ExcelFormDefinitionId,
        'SourceType': 'ExtractedField',
        'SortFieldKey': 'FieldKey',
        'IsCompanySpecific': true,
        'RootUrlKey': 'FileStoreApi',
        'Api': 'FileStoreApi',
        'HasVirtualGridConfig': true,
        'AllowMultipleCheck': true,
        'ShowCheckbox': true,
        'ShowCheckAll': true,
        'IsIndexColumnVisible': false,
        'ServiceName': 'ExtractedFieldDynamicItemService',
        'IsRowStyleEnabled': true,
        'FIELD_SECTION_ID': 'extractedfield',
        'VirtualGridServiceName': 'ExtractedFieldDynamicItemService'
      },
      'filters': []
    };
    this.virtualGridApiService.getVirtualGridItems(req.parameters['SourceType'], req).pipe(take(1)).subscribe(payload => {

      const dic = {};
        payload.items.forEach(x => {
        const obj = x.cells.ExtractedFieldItem.value.fieldValues;
        obj.FieldKey = x.cells.FieldKey.value.fieldKey;
        const key = obj['WorksheetName'] + 'Page' + obj['PageNumber'];
        if (!dic[key]) {
          dic[key] = {};
          const id =  this.flexSheetService.flexSheetStyleManagementService.getCellDomId(obj.CellModel);
          dic[key][id] = obj;
        } else {
          const id =  this.flexSheetService.flexSheetStyleManagementService.getCellDomId(obj.CellModel);
          dic[key][id] = obj;
        }
      });

      this.flexSheetService.flexSheetStyleManagementService.configuredExcelFormFields = dic;
    });
  }
  async getConfiguredFieldsAsync() {
    return new Promise((resolve, reject) => {
      if (!this.selectedTab.tabData.ExcelFormDefinitionId) {
        console.log('TableDefinition Id not found in getConfiguredFieldsAsync');
        resolve({});
        return;
      }
      const req = {
        'startIndex': 0,
        'endIndex': 1000,
        'fieldSectionId': 'extractedfield',
        'sortField': 'FieldKey',
        'isAssending': true,
        'serviceName': 'ExtractedFieldDynamicItemService',
        'api': 'FileStoreApi',
        'parameters': {
          'TableId': this.selectedTab.tabData.ExcelFormDefinitionId,
          'SourceType': 'ExtractedField',
          'SortFieldKey': 'FieldKey',
          'IsCompanySpecific': true,
          'RootUrlKey': 'FileStoreApi',
          'Api': 'FileStoreApi',
          'HasVirtualGridConfig': true,
          'AllowMultipleCheck': true,
          'ShowCheckbox': true,
          'ShowCheckAll': true,
          'IsIndexColumnVisible': false,
          'ServiceName': 'ExtractedFieldDynamicItemService',
          'IsRowStyleEnabled': true,
          'FIELD_SECTION_ID': 'extractedfield',
          'VirtualGridServiceName': 'ExtractedFieldDynamicItemService'
        },
        'filters': []
      };
      this.virtualGridApiService.getVirtualGridItems(req.parameters['SourceType'], req).pipe(take(1)).subscribe(payload => {

        const dic = {};
        payload.items.forEach(x => {
          const obj = x.cells.ExtractedFieldItem.value.fieldValues;
          obj.FieldKey = x.cells.FieldKey.value.fieldKey;
          const key = obj['WorksheetName'] + 'Page' + obj['PageNumber'];
          if (!dic[key]) {
            dic[key] = {};
            const id =  this.flexSheetService.flexSheetStyleManagementService.getCellDomId(obj.CellModel);
            dic[key][id] = obj;
          } else {
            const id =  this.flexSheetService.flexSheetStyleManagementService.getCellDomId(obj.CellModel);
            dic[key][id] = obj;
          }
        });

        this.flexSheetService.flexSheetStyleManagementService.configuredExcelFormFields = dic;
        resolve(dic);
      });
    });
  }
  cleanSelectedCellModel$Subscription() {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
  }
  OnDestroy() {

  }
}

// Command List
// -------------
//   ConfigureExcelAsFormCommandConsumer - PopulateExcelFormDefinition,GetRedirectCommand
// ToggleViewModesForExcelFormCommandConsumer Done/toggle GetResponseDataItem (done copy file->new directryentry)
// CreateCustomFieldForExcelFormCommandConsumer SaveNewExtractedFormFieldItem,SaveNewFieldIntoFlowchartSection
//
// UpdateExcelFormExtractedFieldDefinitionCommandConsumer Update extractedfield  model (can be merged dependency minimal)
// UpdateExcelFormExtractedFieldsCheckStatusCommandConsumer sync extractedfield & flowchart questions based on check uncheck
// CreateNewResponseCommandConsumer
// UpdateExcelFormFromQuestionnaireCommandConsumer update resone to excel (candidate for senario core) flowchartSectionJson serialize check groupby
//
// OpenFileCommand navigation
// ----------------
//   ShowExcelFormDesignCommand state WorkbookSetFormCreator Configure
// ShowExcelFormQuestionnaireCommand state
// ShowExcelFormResponseCommand state
// ShowExcelFormQuestionnaireResponseCommand state
// ShowExcelFormGridViewCommand state

